import { Injectable } from '@angular/core';
import { arrayMapToSome } from '@fmnts/core/rxjs';
import {
  AbstractGraphNodeBuilder,
  ConditionDefinition,
  OperatorNodeDefinition,
} from '@fmnts/declarative-forms/core';

import { PredicateNodeBuilder } from './predicate-node-builder.service';

export enum ArrayOperatorNodeName {
  MapToSomeByCondition = 'array.map-to-some.by-condition',
}

/**
 * Service for building array related graph nodes
 */
@Injectable({
  providedIn: 'root',
})
export class ArrayNodeBuilder extends AbstractGraphNodeBuilder<
  string,
  ArrayOperatorNodeName
> {
  constructor(private pb: PredicateNodeBuilder) {
    super();

    // Add operators
    this.addOperator(
      ArrayOperatorNodeName.MapToSomeByCondition,
      (def: OperatorNodeDefinition<[ConditionDefinition]>) =>
        arrayMapToSome(this.pb.parseCondition(def.args?.[0])),
    );
  }
}
